import type { NoContext } from '~/services/api/contracts/NoContext'
import { CreateAccountSessionRequestSchema } from '~/services/api/generated'
import { strictify } from '~/utils/strictify'

export const PaymentOnboardingSession = (_context: NoContext = {}) =>
  strictify(CreateAccountSessionRequestSchema)
